export const environment = {
  production: false,
  // baseUrl: 'https://localhost',
  baseUrl: 'https://home.bscox.com',
  authServicePort: '8081',
  recipeServicePort: '8083',
  screenServicePort: '8085',
  tileRefreshInterval: 5
};
